export const extractPlayerSurnames = (name: string) => {
  const nameTokens = name.split(' ');
  return nameTokens.length === 1 ? name : nameTokens.slice(1).join(' ');
};
